import { classNames } from "@/react/helpers/twMergeWithCN";
import type { ElementType } from "@/react/types/Element";
import { FormElement } from "./FormElement";

interface VerticalElementsRendererProps {
  errors: Record<number, string>;
  formElements: ElementType[];
  initialFocusRef?: React.RefObject<HTMLInputElement>;
  isPreview: boolean;
  isSubmitting: boolean;
}
export const VerticalElementsRenderer = ({
  formElements,
  isPreview,
  initialFocusRef,
  isSubmitting,
  errors,
}: VerticalElementsRendererProps) => {
  const firstInputIndex = formElements.findIndex(
    element => element.type === "field",
  );
  let fieldCount = 0;

  return (
    <>
      {formElements.map((element, index) => {
        const fieldIndex = element.type === "field" ? fieldCount++ : -1;
        return (
          <FormElement
            key={element.id}
            element={element}
            isPreview={isPreview}
            isSubmitting={isSubmitting}
            errors={errors}
            initialFocusRef={
              index === firstInputIndex ? initialFocusRef : undefined
            }
            fieldIndex={fieldIndex}
            className={classNames({
              "mt-4 !h-auto !py-3": element.type === "button",
            })}
          />
        );
      })}
    </>
  );
};
